"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavigations = exports["default"] = void 0;
var _noSidebar = _interopRequireDefault(require("./noSidebar"));
var _withSidebar = _interopRequireDefault(require("./withSidebar"));
var _progress = _interopRequireDefault(require("./progress"));
var _curriculum = _interopRequireDefault(require("./curriculum"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var builtInNavigations = [_noSidebar["default"], _withSidebar["default"], _progress["default"], _curriculum["default"]];
var appNavigations = function () {
  var context = require.context('resources/assets/js', true, /^\.\/vendor\/assignment\/navigations\.js$/);
  if (context.keys().length > 0) {
    var filematches = context(context.keys()[0]);
    return filematches["default"] || filematches;
  }
  return [];
}();
var allNavigations = [].concat(builtInNavigations, _toConsumableArray(appNavigations));

/* keeping this default export to keep backwards compatibility with any apps
 * that import from cccisd-laravel-assignment/dist folder. Moving forward,
 * we should always be using getNavigations function instead.
 */
var _default = exports["default"] = allNavigations;
var getNavigations = exports.getNavigations = function getNavigations() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    noCurriculum = _ref.noCurriculum,
    noCourseWrapper = _ref.noCourseWrapper,
    restrictionsLevel = _ref.restrictionsLevel,
    requiredNavigation = _ref.requiredNavigation;
  if (['basic', 'premium'].includes(restrictionsLevel)) {
    return allNavigations.filter(function (nav) {
      return ['noSidebar', 'withSidebar', 'progress'].includes(nav.handle) || nav.handle === requiredNavigation;
    });
  }

  // must be explicitly true, by default show all navigations
  return allNavigations.filter(function (nav) {
    return !noCurriculum || !nav.handle.startsWith('curriculum');
  }).filter(function (nav) {
    return !noCourseWrapper || !nav.handle.startsWith('courseWrapper');
  });
};